import React from 'react'

import { SvgArrowTriangleDown } from '@chilipiper/icons/src/arrow/ArrowTriangleDown'
import { ThemeColors } from '../../new/theme/colors'

import { Icon } from '../../new/core-components/icon'
import { Box } from '../../new/core-components/box'
import { TextField } from '../text-field/TextField'
import { Field, Props as FieldProps } from '../text-field/Field'
import { UnstyledButton } from '../button'

type ModeType = 'ENABLE_TYPING' | 'SELECT_ONLY'

export type Props = {
  arrowColor?: ThemeColors
  arrowDownHidden?: boolean
  mode: ModeType
} & FieldProps

export const InputField = React.forwardRef(
  (
    {
      value,
      label,
      onChange,
      id,
      mode,
      onClick,
      onFocus,
      placeholder,
      focused,
      arrowDownHidden,
      arrowColor,
      ...others
    }: Props,
    ref
  ) => {
    const props = {
      id,
      label,
      endContent: !arrowDownHidden && (
        <Box w={3} color={arrowColor || 'icon/indicator'}>
          <Icon icon={SvgArrowTriangleDown} pointer />
        </Box>
      ),
      value: value,
      onFocus: onFocus,
      focused,
    }
    const InputNode = {
      SELECT_ONLY: (
        <Field
          {...others}
          {...props}
          placeholder={placeholder}
          h={label ? 11 : 8}
          roundedBottomCorners
        />
      ),
      ENABLE_TYPING: (
        <TextField {...others} {...props} ref={ref} onChange={onChange} placeholder={placeholder} />
      ),
    }[mode]
    return (
      <UnstyledButton m={0} p={0} w='100%' h='100%' onClick={onClick}>
        {InputNode}
      </UnstyledButton>
    )
  }
)

InputField.displayName = 'InputField'
